<img
  [alt]="imageModel?.alt"
  [src]="this.safeImageSrc"
  [width]="this.imageModel?.width"
  [height]="this.imageModel?.height"
  [style.object-fit]="this.imageModel?.objectFit"
  [style.max-width]="this.imageModel?.width"
  [style.max-height]="this.imageModel?.height"
/>
